import {ErrorHandler, Provider} from '@angular/core';
import {SentryService} from '@q9elements/ui-kit/common';

export function provideErrorHandler(): Provider {
  const sentryService = new SentryService();

  return {
    provide: ErrorHandler,
    useValue: sentryService.createErrorHandler()
  };
}
